import type { Anniversary15BannerVariant } from './types';

export const ANNIVERSARY_LANDING_URL = '/15years';

export const ASSETS_HOST = 'https://assets.travelatacdn.ru/';

interface Anniversary15BannerImage {
    readonly path: string;
    readonly maxDensity: number;
    readonly alt: string;
}

const PROMO_TEXT = 'Нам 15 лет! Дарим призы на 1 млн рублей. Участвовать';

export const ANNIVERSARY_BANNERS: Record<Anniversary15BannerVariant, Anniversary15BannerImage> = {
    main: {
        path: 'travelata/promo/anniversary15/banner-main.webp',
        maxDensity: 2,
        alt: PROMO_TEXT,
    },
    serp: {
        path: 'travelata/promo/anniversary15/banner-serp.webp',
        maxDensity: 2,
        alt: 'Нам 15 лет! Дарим призы на 1 млн ₽. Участвовать',
    },
    serpMobile: {
        path: 'travelata/promo/anniversary15/banner-serp-mobile.webp',
        maxDensity: 3,
        alt: PROMO_TEXT,
    },
    top: {
        path: 'travelata/promo/anniversary15/top-banner.webp',
        maxDensity: 3,
        alt: '15 лет вместе с Травелатой! Дарим призы на 1 млн рублей. Участвовать',
    },
};
